/* eslint-disable jsx-a11y/anchor-is-valid */
const NavBar = () => {
    return (
        <nav className="navbar py-2" role="navigation" aria-label="main navigation">
            <div className="navbar-brand container">
                <a className="navbar-item" href="#">
                    <h5 className="title is-5">Where in the world?</h5>
                </a>
            </div>
        </nav>
    )
}

export default NavBar